import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import ServicesGrid from '../components/ServicesGrid';
import WhyChooseUs from '../components/WhyChooseUs';
import ServiceAreas from '../components/ServiceAreas';
import Testimonials from '../components/Testimonials';
import Gallery from '../components/Gallery';
import Contact from '../pages/Contact';

const Home = () => (
  <main id="home">
    <Helmet>
      <title>Lawns Out West | Lawn Mowing & Garden Services Melbourne’s West</title>
      <meta name="description" content="Lawn mowing, edging, weeding, hedging, pruning, tree lopping, lawn repair, green waste and pressure cleaning across Weir Views, Altona Meadows, Williamstown, Point Cook, Sunshine, Footscray & surrounds." />
      <script type="application/ld+json">{`
      {
        "@context":"https://schema.org",
        "@type":"LocalBusiness",
        "name":"Lawns Out West",
        "url":"https://lawnsoutwest.com.au",
        "telephone":"+61423358158",
        "email":"lawnsoutwest@outlook.com",
        "areaServed":"Melbourne’s West",
        "sameAs":[
          "https://www.facebook.com/LawnsOutWest",
          "https://www.instagram.com/lawnsoutwest"
        ]
      }
      `}</script>
    </Helmet>
    <Hero />
    <section className="section" id="about">
      <div className="container" style={{ display: 'grid', gap: '1.25rem', gridTemplateColumns: '1.5fr 1fr' }}>
        <div>
          <h2 className="section-title" style={{ textAlign: 'left' }}>About Us</h2>
          <p className="muted">We’re a friendly, locally owned business proudly serving Melbourne’s western suburbs. We care about quality, reliability and leaving every lawn looking its best, every time.</p>
          <div className="card" style={{ marginTop: '0.75rem' }}>
            <strong>“Our clients love the transformation!”</strong>
          </div>
        </div>
        <div className="card">
          <h3>Fast Free Quote</h3>
          <p className="muted">Tell us what you need and we’ll be in touch.</p>
          <a href="#contact" className="btn">Get a Free Quote</a>
        </div>
      </div>
    </section>
    <ServicesGrid />
    <WhyChooseUs />
    <ServiceAreas />
    <div id="testimonials"><Testimonials /></div>
    <Gallery />
    <Contact />
  </main>
);

export default Home;


